import { createContext, type ElementType } from 'react';
import { type ImageProps, type ImgPropsReturn, type NextgenImageProviderInterface } from './types/propsTypes';

interface ContextInterface {
  element: ElementType;
  useCDNForCS: boolean;
  getImageProps?: (imgProps: ImageProps) => ImgPropsReturn;
}

const NextgenImageContext = createContext<ContextInterface>({} as ContextInterface);

const NextgenImageProvider = ({
  element,
  children,
  useCDNForCS = false,
  getImageProps,
}: NextgenImageProviderInterface) => (
  <NextgenImageContext.Provider value={{ element, useCDNForCS, getImageProps } as ContextInterface}>
    {children}
  </NextgenImageContext.Provider>
);

export { NextgenImageProvider, NextgenImageContext };
